import React, { useState } from 'react';
import { getRandomImage, secondsToHoursAndMinutes } from '../../hooks';
import { useTranslation } from 'react-i18next';

export const PathwayItems = ({ data, index }) => {
  const { t } = useTranslation('library');
  const [optionsVisible, setOptionsVisible] = useState(false);

  const url =
    data._index === 'ibl-dm.public.dl_catalog_app_course'
      ? `/courses/${data._source?.course_id ?? ''}`
      : '';

  const getCourseDuration = (duration) => {
    let time;
    try {
      time = secondsToHoursAndMinutes(duration);
      if (time === 'NaN:NaN') {
        time = duration;
      }
    } catch (e) {
      time = duration;
    }

    return time;
  };

  const [edxData, duration, shortDescription] = data?._source?.edx_data
    ? (() => {
        try {
          const parsedData = JSON.parse(data._source.edx_data);
          return [
            parsedData,
            parsedData?.duration ?? '',
            parsedData?.short_description ?? '',
          ];
        } catch (error) {
          console.error('Failed to parse edx_data:', error);
          return ['', '', ''];
        }
      })()
    : ['', '', ''];

  const [level] = data?._source?.data
    ? (() => {
        try {
          const parsedData = JSON.parse(data._source.data);
          return [parsedData?.level ?? ''];
        } catch (error) {
          console.error('Failed to parse data:', error);
          return [''];
        }
      })()
    : [''];

  const toggleOptions = () => setOptionsVisible(!optionsVisible);
  const hideOptions = () => setOptionsVisible(false);

  const handleRemoveItemClick = () => {
    // Define what happens on item removal
  };

  return (
    <>
      <div className="units_block mgt30">
        <div className="unit_num">
          <div className="number">
            <div className="l_bel"></div>
            <div className="div-block-72">
              <div className="div-block-70">
                <img
                  alt=""
                  className="image-46"
                  loading="lazy"
                  src="/images/62a334c5a2b21b82f0ac43fc_hexagon_162a334c5a2b21b82f0ac43fc_hexagon.png"
                />
                <div className="num reg">{index + 1}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="unit_listing path">
          <div className="course-rec-3-wide">
            <a className="course_link_wide w-inline-block" href={url}>
              <div className="course-header-rec-3-wide">
                <img
                  alt=""
                  className="image-34-wide"
                  height={30}
                  src={getRandomImage()}
                />
                <div className="unit_type_div w-clearfix">
                  <img
                    alt=""
                    className="type_img"
                    loading="lazy"
                    src="/images/play-button_2play-button.png"
                  />
                  <div className="text-block-52">{t('Course')}</div>
                </div>
              </div>
              <div className="course-body-4-wide">
                <div className="unit-wide-header-holder">
                  <div className="text-block-39 wide">
                    {data?.name ?? data?._source?.name}
                    <br />
                  </div>
                  <div className="div-block-23 p">
                    <div className="div-block-24">
                      <img
                        alt=""
                        className="image-18"
                        loading="lazy"
                        sizes="100vw"
                        src="images/google.png"
                        srcSet="images/google-p-500.png 500w, images/google.png 512w"
                      />
                    </div>
                    <div className="text-block-16 p">Google</div>
                  </div>
                  <div className="unit-wide-description">
                    {shortDescription}
                  </div>
                </div>
                <div className="line4 n t"></div>
                <div className="course-features">
                  <div className="div-block-74 first_row wide">
                    {level && (
                      <div className="div-block-73 wide">
                        <div className="faq-wrap-3">
                          <img
                            alt=""
                            className="img-trg-4"
                            sizes="(max-width: 991px) 20px, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                            src="/images/62a334c5a2b21b27b6ac43de_volume.png"
                            srcSet="/images/62a334c5a2b21b27b6ac43de_volume-p-500.png 500w, /images/62a334c5a2b21b27b6ac43de_volume.png 512w"
                          />
                          <div className="features_block-2">
                            <div className="features-title-5">{level}</div>
                          </div>
                        </div>
                      </div>
                    )}
                    {duration && (
                      <div className="div-block-73 wide">
                        <div className="faq-wrap-3" style={{ width: 'auto' }}>
                          <img
                            alt=""
                            className="img-trg-4"
                            sizes="(max-width: 991px) 20px, (max-width: 1279px) 2vw, (max_width: 1439px) 20px, 1vw"
                            src="/images/62a334c5a2b21b394dac43e3_clock.png"
                            srcSet="/images/62a334c5a2b21b394dac43e3_clock-p-500.png 500w, /images/62a334c5a2b21b394dac43e3_clock.png 512w"
                          />
                          <div className="features_block-2">
                            <div className="features-title-5">
                              {getCourseDuration(duration)}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="div-block-73 wide mg-lauto">
                      {optionsVisible && (
                        <div
                          className="options_div cr-pathway active"
                          onBlur={hideOptions}
                        >
                          <div
                            className="text-block-103 remove_item"
                            onClick={handleRemoveItemClick}
                          >
                            {t('Remove')}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
